import React, { useState } from "react";
import Drawer from "@mui/material/Drawer";
import List from "@mui/material/List";
import Divider from "@mui/material/Divider";
import { useDispatch, useSelector } from "react-redux";
import logo from "../../../../assets/logo.svg";
import styled from "@emotion/styled";

const MobileMainMenu = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;

  @media (min-width: 1057px) {
    display: none;
  }
`;

const SiteLogo = styled.img`
  width: 150px;
  height: 50px;
`;

const MenuButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px;

  @media (max-width: 600px) {
    position: absolute;
    right: 10px;
  }
`;

const DrawerBox = styled.div`
  width: 250px;
  padding: 1rem;
`;

const DrawerDivider = styled.div`
  margin-bottom: 1rem;
`;

const MenuLinkStyled = styled.a`
  display: block;
  text-decoration: none;
  padding: 10px;
  color: #000;
  font-size: 1.2rem;
 
`;

const HamburgerIcon = styled.label`
  cursor: pointer;

  input {
    display: none;
  }

  svg {
    height: 3em;
    transition: transform 600ms cubic-bezier(0.4, 0, 0.2, 1);
  }

  .line {
    fill: none;
    stroke: black;
    stroke-linecap: round;
    stroke-linejoin: round;
    stroke-width: 3;
    transition: stroke-dasharray 600ms cubic-bezier(0.4, 0, 0.2, 1),
                stroke-dashoffset 600ms cubic-bezier(0.4, 0, 0.2, 1);
  }

  .line-top-bottom {
    stroke-dasharray: 12 63;
  }

  input:checked + svg {
    transform: rotate(-45deg);
  }

  input:checked + svg .line-top-bottom {
    stroke-dasharray: 20 300;
    stroke-dashoffset: -32.42;
  }
`;

const Dropdown = styled.div`
  display: ${(props) => (props.open ? "block" : "none")};
  padding-left: 15px;


  a {
    padding: 8px 15px;
    display: block;
    text-decoration: none;
    color: #000;
    font-size: 14px;
    transition: background-color 0.3s, color 0.3s;

    &:hover {
      color: #bf46a2;
    }
  }
`;

const DropdownBox = styled.div`
 background: #F4FAFF; 
    border-radius: 10px;
    padding: 8px 0;
     
  border-radius: 6px;
  padding: ${(props) => (props.active ? "5px" : "0")};
`;

const MobileMenu = (props) => {
  const currentTheme = useSelector((state) => state.LDTheme.value);
  const dispatch = useDispatch();
  const [state, setState] = useState({ left: false });
  const [isChecked, setIsChecked] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false); 

  const toggleDrawer = (anchor, open) => (event) => {
    if (event.type === "keydown" && (event.key === "Tab" || event.key === "Shift")) {
      return;
    }
    setState({ ...state, [anchor]: open });
    if (!open) {
      setIsChecked(false);  
    }
  };

  const handleHamburgerClick = () => {
    setIsChecked(!isChecked);  
  };

  const toggleDropdown = (event) => {
    event.stopPropagation();  
    setDropdownOpen(!dropdownOpen); 
  };

  return (
    <MobileMainMenu>
      <MenuLinkStyled href="/" p="15px 0 15px">
        <SiteLogo src={logo} width="150" height="50" />
      </MenuLinkStyled>

      <MenuButton onClick={toggleDrawer("left", true)}>
        <HamburgerIcon>
          <input type="checkbox" checked={isChecked} onChange={handleHamburgerClick} />
          <svg viewBox="0 0 32 32">
            <path
              className="line line-top-bottom"
              d="M27 10 13 10C10.8 10 9 8.2 9 6 9 3.5 10.8 2 13 2 15.2 2 17 3.8 17 6L17 26C17 28.2 18.8 30 21 30 23.2 30 25 28.2 25 26 25 23.8 23.2 22 21 22L7 22"
            ></path>
            <path className="line" d="M7 16 27 16"></path>
          </svg>
        </HamburgerIcon>
      </MenuButton>

      <Drawer anchor="left" open={state["left"]} onClose={toggleDrawer("left", false)}>
        <DrawerBox role="presentation" onClick={toggleDrawer("left", false)} onKeyDown={toggleDrawer("left", false)}>
          <DrawerDivider>
            <MenuLinkStyled href="/">
              <SiteLogo src={logo} width="150" height="50" />
            </MenuLinkStyled>
            <Divider />
            <List>
              {props.menuList.map((value, i) => (
                <div key={i}>
                  <MenuLinkStyled
                    href={value.link}
                    target={value.target}
                    className={value.customClass + " d-block"}
                    onClick={(e) => {
                      if (value.title === "KnowledgeBase") {
                        toggleDropdown(e);  
                      }
                    }}
                  >
                    {value.title}
                  </MenuLinkStyled>

                  {value.title === "KnowledgeBase" && (
                    <DropdownBox active={dropdownOpen}>
                      <Dropdown open={dropdownOpen}>
                        <a href="https://aicm-store.gitbook.io/whitepaper/user-guides/service-listing-workflow" target="_blank">
                          Create a store
                        </a>
                        <a href="https://aicm-store.gitbook.io/whitepaper/user-guides/advertising-on-aicm" target="_blank">
                          Advertise
                        </a>
                        <a href="https://aicm-store.gitbook.io/whitepaper/user-guides/affiliate-program" target="_blank">
                          Affiliate program
                        </a>
                      </Dropdown>
                    </DropdownBox>
                  )}
                </div>
              ))}
            </List>
          </DrawerDivider>
        </DrawerBox>
      </Drawer>
    </MobileMainMenu>
  );
};

export default MobileMenu;
